import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { labelForNavId } from "../../navigation/navigation";

export function PlaceholderView() {
  const { section } = useParams();
  const title = useMemo(
    () => labelForNavId(section ?? "") ?? "Dashboard",
    [section],
  );

  return (
    <div className="h-full overflow-auto bg-background">
      <div
        className="bg-card border-b border-border px-4 md:px-6"
        style={{
          paddingTop: "var(--spacing-page-header-top)",
          paddingBottom: "var(--spacing-page-header-bottom)",
        }}
      >
        <h1
          className="text-foreground"
          style={{
            fontSize: "var(--text-h2)",
            fontWeight: "var(--font-weight-semi-bold)",
            lineHeight: "1.3",
          }}
        >
          {title}
        </h1>
        <p
          style={{
            fontSize: "var(--text-base)",
            marginTop: "var(--spacing-title-subtitle)",
            color: "var(--subtitle-text)",
          }}
        >
          Conteúdo em construção (copy-first do Figma Make).
        </p>
      </div>

      <div className="px-4 md:px-6 py-6 md:py-8">
        <div
          className="bg-card border border-border p-6"
          style={{
            borderRadius: "var(--radius-card)",
            boxShadow: "var(--elevation-sm)",
          }}
        >
          <p
            className="text-secondary-text"
            style={{ fontSize: "var(--text-base)" }}
          >
            Esta área será preenchida quando copiarmos a página
            correspondente do ui-figma-make.
          </p>
        </div>
      </div>
    </div>
  );
}
